jQuery(document).ready(function($) {
  // Dropdown Menu Start
  $(".mobile-nav-toggle").click(function(){
    $(this).toggleClass("mobile-nav--close");
    $("#AccessibleNav").stop(true).slideToggle()
  });

  // Dropdown Menu Custom
  function doMainMenu() {
    if($(window).width() > 990) {
      $('#AccessibleNav').show();
      $( ".site-nav--has-dropdown" ).hover(function() {
        var $this = $(this);
        var height_header = $( "#shopify-section-header" ).height(); //console.log(height_header);
        var height_dopdown = $this.find( ".site-nav__dropdown" ).height(); //console.log(height_dopdown);
        $( ".custom_bg" ).height( height_dopdown + 32 ).css({"top":height_header+"px"}).addClass( "fadeIn" );
        var interval_menu = setInterval(function() {
          custom_maindropdown(interval_menu);
        },500);
      });
      function custom_maindropdown(interval_menu){
        if( $( ".site-nav--has-dropdown" ).hasClass( "site-nav--active-dropdown" ) == false){
          $( ".custom_bg" ).removeClass( "fadeIn" );
          clearTimeout(interval_menu);
        }
      }
    } else {
      $( ".site-nav--has-dropdown" ).toggleClass( "site-nav--active-dropdown" );
      $( ".site-nav--has-dropdown" ).click(function() {
        var $this = $(this);
        $this.toggleClass( "site-nav--active-dropdown" );
      });
    }
  }doMainMenu();
  $( window ).resize(function() {
    doMainMenu();
  });

  // Product Details
  $( ".product-form .option_color li" ).click(function(){
    $( ".product-form .option_color li" ).removeClass( "active" );
    $(this).addClass( "active" );
    var color = $(this).attr( "data-color" );
    var select_id = $(this).parent().attr( "data-option" );
  });

  $( "#tabs" ).tabs();

  // $(".link_size_guide").fancybox();
  $('[data-fancybox="gallery"]').fancybox({
    // Options will go here
  });
  // Product slider
  $('.product_slider_text li').click(function(){
    $('.product_slider_text li').removeClass('active');
    $('span').removeClass('active');
    $(this).addClass('active');
    var slider = '#product_slider .jcarousel';
    var slide_nr = $(this).data('slide') - 1;
    var pin_nr = $(this).data('pin'); console.log(pin_nr);
    $(slider).jcarousel('scroll', $(slider + ' li:eq(' + slide_nr + ')'));
    slide_nr = slide_nr + 1;
    $('#pin-' + slide_nr + '-' + pin_nr).addClass('active');
  });

  // Product Review
  $(document).on('click', '.spr-summary-actions-newreview', function() {
    $(this).toggleClass('active');/*(function() {
        $(this).text('Close');
      }, function() {
        $(this).text('Write a review');
      }
    );*/
  });

  // Video Block
  $( ".oat_video_block a" ).click(function(e){
    e.preventDefault();

    var video_link = $( this ).attr( "href" ); video_link = video_link.replace("#event=showvideo|iframeUrl=", "");
    $( this ).parent().html( "" ).append( '<iframe width="970" height="500" src="'+video_link+'" frameborder="0" allowfullscreen=""></iframe>' );
  });

  // FAQ
  $( "#accordion" ).accordion({collapsible : true, active : 0, header: ".a_title", heightStyle: "content"});

  // Popup
  // var pathname = window.location.pathname;
  // if(pathname !== '/pages/design-solutions'){
  //   var newsletter = $.cookie('newsletter');
  //   if(newsletter == undefined || newsletter == 0){
  //     setTimeout(function(){ $(".popup").show(); }, 20000);
  //   }
  // }

  function set_cookies_newsletter(email){
    $(".popup").hide();
    $.cookie('newsletter', 1, { expires: 7, path: '/' });
  }
  $( ".popup .newsletter__submit" ).click(function(e){
    var email = $('.popup input[type=email]').val();
    var v_email = /(\w+)[@](\w+)[.](\D+)/;
    var result_email = v_email.exec(email);
    if( email != '' && result_email != null ) {
      set_cookies_newsletter(email);
    }else{
      e.preventDefault();
    }
  });

  $( ".cbutton_subscribe" ).click(function(e){
    e.preventDefault();

    $.fancybox({
      href: '#subscribe',
      modal: true
    });
    $( ".popup" ).show();
  });

  $( ".popup .close, .newsletter__submit" ).click(function(){
    $.fancybox.close();
    $(".popup").hide();
    $.cookie('newsletter', 2, { expires: 7, path: '/' });
    $( ".popup" ).hide();
  });

  // Collection
  // $( ".dspe_img" ).hover(
  //   function() {
  //     $( this ).find( ".gii_2" ).stop(true).fadeIn(400);
  //   }, function() {
  //     $( this ).find( ".gii_2" ).stop(true).fadeOut(400);
  //   }
  // );

  $( ".grid-view-item__colors .option_color.active li" ).click(function() {
    var $this = $(this);
    var i = 1;
    var color = $this.data('color');
    var selector = $this.data('product');
    var images_element = $this.parent().parent().parent().parent().find('.gi_image');$(images_element).html("");
    var obj = JSON.parse($('#'+selector).html());

    $this.parent().find('li').removeClass( "active" );
    $this.addClass( "active" );

    $.each( obj.images, function( key, value ) {
      if( value.image_alt.toLowerCase() === color ){
        $(images_element).append('<img src="' + value.image_thumbnail + '" alt="' + value.image_alt + '" class="gii_'+i+'">');
        i += 1;
      }
    });
  });

  // Instagram Feed
  var resizeId2;
  var $insta_feed = $('#insta-feed');
  function sliderInstaFeed() {
    if( $('#insta-feed > a, #insta-feed > ul').length > 0 ) {
      if ($(window).width() <= 736) {
        $insta_feed.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        });
      } else {
        if ($insta_feed.hasClass("slick-initialized") === true) {
          $insta_feed.slick('unslick');
        }
      }

      clearInterval(resizeId2);
    }
  }
  resizeId2 = setInterval(sliderInstaFeed,500);

  $( window ).resize(function() {
    clearInterval(resizeId2);
    resizeId2 = setInterval(sliderInstaFeed,500);
  });

  // About Us
  $(".various").fancybox({
    maxWidth  : 800,
    maxHeight  : 600,
    fitToView  : false,
    autoSize  : false,
    closeClick  : false,
    openEffect  : 'none',
    closeEffect  : 'none',
    wrapCSS: 'video'
  });


  // $('.logo-bar').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   settings: "unslick",
  //   responsive: [
  //     {
  //       breakpoint: 9999,
  //       settings: "unslick"
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         settings: "unslick",
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true,
  //         arrows: false,
  //       }
  //     }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
  //   ]
  // });


});
